import { render, staticRenderFns } from "./WheelsetWheelBasedata.vue?vue&type=template&id=4a616a89&scoped=true"
import script from "./WheelsetWheelBasedata.vue?vue&type=script&lang=js"
export * from "./WheelsetWheelBasedata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a616a89",
  null
  
)

export default component.exports